import { Method } from 'axios';
import ApiRoutes from './ApiRoutes';
import config from '../../config';
import { IApiAssignableVoucherInfo } from '../common/interfaces/vouchers.interface';
import { TApiResponse } from '../common/types/api.types';

const CARTAPI_BASEURL: string = config.cartApi.baseurl;

export default class CartApiRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> extends ApiRoutes<TApiResponse<TResponse>, TRequestData, TRequestParams> {
  // Vouchers
  public static assignVoucherToDownlineCustomer = new CartApiRoutes<IApiAssignableVoucherInfo[], { customerNumber: number }, { voucherCode: string }>(`/vouchers/:voucherCode/downline-customer`, `put`, true);
  public static getVouchersAssignableToDownline = new CartApiRoutes<IApiAssignableVoucherInfo[]>(`/vouchers/assignable-to-downline`, `get`, true);

  constructor(url: string, method: Method, withCredentials = false) {
    super(url, method, withCredentials, CARTAPI_BASEURL);
  }
}
